import layout from '@/layout'

export default {
  path: '/shareholders',
  component: layout,
  redirect: '/shareholders/winner',
  name: 'shareholdersWinner',
  meta: {
    title: 'shareholders',
    icon: 'shareholders'
  },
  children: [
    {
      path: '/shareholders/winner',
      name: 'shareholdersWinner',
      component: () => import('@/views/shareholders_winner/index'),
      meta: {
        title: 'shareholdersWinner',
        icon: 'shareholders'
      }
    }
  ]
}
